import Urls from "../../constants/urls";
import seat1 from "./imgs/seat1.jpeg";
import seat2 from "./imgs/seat2.jpeg";
import bohemianWines from "./imgs/bohemian.jpeg";
import bohoWines from "./imgs/boho.jpeg";
import cutWines from "./imgs/cut.jpeg";
import sparklingWines from "./imgs/spark.jpeg";

export const shopifyData = {
    domain: process.env.REACT_APP_WC_SHOPIFY_DOMAIN,
    token: process.env.REACT_APP_WC_SHOPIFY_TOKEN,
    productIds: [
        // Sparkling
        "6632267055279", // Fidelia Chatmat White
        "6632256340143", // 2020 Angelica Frizzante
        "6632266203311", // Musette Frizzante White
        // Cut
        "6632252965039", // 2019 Sauvignon Blanc
        "6632257061039", // 2019 Syrah
        "6632254079151", // 2019 Muscat Canelli
        "6632256340143", // 2020 Rose
        "6632255193263", // Gruner Veltliner
        // Boho
        "6632257814703", // 2019 Boho Beat
        "6632258863279", // 2019 BOHO Zen
        // Bohemian
        "6632260599983", // 2020 Bohemian Blanc
        "6632259616943", // 2019 Bohemian Rouge
        "6632262992047", // 2020 Bohemian Riesling
    ],
};
  

export const seat1Hotspots = [
    {
        type: "arrow",
        xPosition: 17,
        yPosition: -25,
        zPosition: 50,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 6,
        link: Urls.winemakersCut.cutWines.path,
        linkRotation: 83,
    },
    {
        type: "arrow",
        xPosition: 17,
        yPosition: -25,
        zPosition: -55,
        xRotation: -90,
        yRotation: -90,
        zRotation: 180,
        radius: 6,
        link: Urls.winemakersCut.bohoWines.path,
        linkRotation: 83,
    },
];

export const seat2Hotspots = [
    {
        type: "arrow",
        xPosition: 32,
        yPosition: -25,
        zPosition: 50,
        xRotation: -90,
        yRotation: -180,
        zRotation: 85,
        radius: 8,
        link: Urls.winemakersCut.bohemianWines.path,
    },
    {
        type: "arrow",
        xPosition: 33,
        yPosition: -25,
        zPosition: -55,
        xRotation: -90,
        yRotation: -90,
        zRotation: 185,
        radius: 8,
        link: Urls.winemakersCut.sparklingWines.path,
    }
];

export const bohoHotspots = [
    {
        type: "spot",
        zPosition: 22,
        yPosition: -25,
        xPosition: 110,
        xRotation: -100,
        yRotation: 90,
        zRotation: 90,
        radius: 7,
        link: Urls.winemakersCut.seat1.path,
        linkRotation: 83,
    },
    {
        type: "arrow",
        zPosition: -5,
        yPosition: -35,
        xPosition: 110,
        xRotation: -100,
        yRotation: 90,
        zRotation: -90,
        radius: 8,
        link: Urls.winemakersCut.cutWines.path,
        linkRotation: 83,
    },
    {
        type: "arrow",
        yPosition: -30,
        zPosition: 60,
        xPosition: 15,
        xRotation: 280,
        yRotation: 180,
        zRotation: 90,
        radius: 8,
        link: Urls.winemakersCut.bohemianWines.path,
        linkRotation: 83,
    },
    {
        type: "cart",
        xPosition: -12,
        yPosition: -1,
        zPosition: 9,
        yRotation: 110,
        radius: 1,
        productId: "6632257814703", // 2019 Boho Beat
    },
    {
        type: "cart",
        xPosition: -12,
        yPosition: -1,
        zPosition: -8,
        yRotation: 70,
        radius: 1,
        productId: "6632258863279", // 2019 BOHO Zen
    },
];

export const bohemianHotspots = [
    {
        type: "arrow",
        zPosition: 5,
        yPosition: -25,
        xPosition: 100,
        xRotation: -100,
        yRotation: 90,
        zRotation: -85,
        radius: 8,
        link: Urls.winemakersCut.sparklingWines.path,
        linkRotation: 83,
    },
    {
        type: "spot",
        zPosition: -25,
        yPosition: -35,
        xPosition: 150,
        xRotation: -100,
        yRotation: 90,
        zRotation: 270,
        radius: 8,
        link: Urls.winemakersCut.seat2.path,
        linkRotation: 83,
    },
    {
        type: "arrow",
        yPosition: -30,
        zPosition: -45,
        xPosition: 17,
        xRotation: 280,
        yRotation: 180,
        zRotation: -90,
        radius: 8,
        link: Urls.winemakersCut.bohoWines.path,
        linkRotation: 83,
    },
    {
        type: "cart",
        xPosition: -12,
        yPosition: -1,
        zPosition: 7,
        yRotation: 110,
        radius: 1,
        productId: "6632260599983", // 2020 Bohemian Blanc
    },
    {
        type: "cart",
        xPosition: -12,
        yPosition: -1,
        zPosition: -6,
        yRotation: 70,
        radius: 1,
        productId: "6632259616943", // 2019 Bohemian Rouge
    },
    {
        type: "cart",
        xPosition: -12,
        yPosition: -12,
        zPosition: 0,
        xRotation: -20,
        yRotation: 90,
        radius: 1,
        productId: "6632262992047", // 2020 Bohemian Riesling
    },     
];

export const cutHotspots = [
    {
        type: "arrow",
        zPosition: 6,
        yPosition: -25,
        xPosition: 80,
        xRotation: -100,
        yRotation: 90,
        zRotation: 275,
        radius: 6,
        link: Urls.winemakersCut.bohoWines.path,
        linkRotation: 83,
    },
    {
        type: "spot",
        zPosition: -18,
        yPosition: -25,
        xPosition: 105,
        xRotation: -100,
        yRotation: 90,
        zRotation: 255,
        radius: 6,
        link: Urls.winemakersCut.seat1.path,
        linkRotation: 83,
    },
    {
        type: "arrow",
        yPosition: -30,
        zPosition: -65,
        xPosition: 20,
        xRotation: 280,
        yRotation: 0,
        zRotation: 90,
        radius: 7,
        link: Urls.winemakersCut.sparklingWines.path,
        linkRotation: 83,
    },
    {
        type: "cart",
        xPosition: -12,
        yPosition: -1,
        zPosition: 16,
        yRotation: 150,
        radius: 1,
        productId: "6632252965039", // 2019 Sauvignon Blanc
    },
    {
        type: "cart",
        xPosition: -12,
        yPosition: -1,
        zPosition: 1,
        yRotation: 90,
        radius: 1,
        productId: "6632257061039", // 2019 Syrah
    },
    {
        type: "cart",
        xPosition: -12,
        yPosition: -1,
        zPosition: -14,
        yRotation: 50,
        radius: 1,
        productId: "6632254079151", // 2019 Muscat Canelli
    },
    {
        type: "cart",
        xPosition: -12,
        yPosition: -16,
        zPosition: 9.5,
        xRotation: -40,
        yRotation: 90,
        radius: 1.5,
        productId: "6632256340143", // 2020 Rose
    },
    {
        type: "cart",
        xPosition: -12,
        yPosition: -16,
        zPosition: -7,
        xRotation: -40,
        yRotation: 90,
        radius: 1.5,
        productId: "6632255193263", // Gruner Veltliner
    },
];

export const sparklingHotspots = [
    {
        type: "spot",
        zPosition: 19,
        yPosition: -25,
        xPosition: 100,
        xRotation: -100,
        yRotation: 90,
        zRotation: 90,
        radius: 6,
        link: Urls.winemakersCut.seat2.path,
        linkRotation: 83,
    },
    {
        type: "arrow",
        zPosition: -5,
        yPosition: -35,
        xPosition: 105,
        xRotation: -100,
        yRotation: 90,
        zRotation: -95,
        radius: 8,
        link: Urls.winemakersCut.bohemianWines.path,
        linkRotation: 83,
    },
    {
        type: "arrow",
        yPosition: -30,
        zPosition: 40,
        xPosition: 15,
        xRotation: 280,
        yRotation: 180,
        zRotation: 90,
        radius: 7,
        link: Urls.winemakersCut.cutWines.path,
        linkRotation: 83,
    },
    {
        type: "cart",
        xPosition: -12,
        yPosition: -1,
        zPosition: 12,
        yRotation: 120,
        radius: 1,
        productId: "6632267055279", // Fidelia Chatmat White
    },
    {
        type: "cart",
        xPosition: -12,
        yPosition: -1,
        zPosition: -7.5,
        yRotation: 60,
        radius: 1,
        productId: "6632256340143", // 2020 Angelica Frizzante Rose
    },
    {
        type: "cart",
        xPosition: -12,
        yPosition: -10,
        zPosition: 1,
        xRotation: -20,
        yRotation: 90,
        radius: 1,
        productId: "6632266203311", // Musette Frizzante White
    },
];

export const rooms = [
    {
        name: "Seat 1",
        img: seat1,
        route: Urls.winemakersCut.seat1,
        yRotation: 360,
        linkRotation: 83,
    },
    {
        name: "Seat 2",
        img: seat2,
        route: Urls.winemakersCut.seat2,
        yRotation: 90,
        linkRotation: 83,
    },
    {
        name: "Bohemian Wines",
        img: bohemianWines,
        route: Urls.winemakersCut.bohemianWines,
        yRotation: 90,
        linkRotation: 83,
    },
    {
        name: "Boho Wines",
        img: bohoWines,
        route: Urls.winemakersCut.bohoWines,
        yRotation: 90,
        linkRotation: 83,
    },
    {
        name: "Sparkling Wines",
        img: sparklingWines,
        route: Urls.winemakersCut.sparklingWines,
        yRotation: 90,
        linkRotation: 83,
    },
    {
        name: "Cut Wines",
        img: cutWines,
        route: Urls.winemakersCut.cutWines,
        yRotation: 90,
        linkRotation: 83,
    },
];
